import styled, { css } from "styled-components";
import { getThemeStatus, getThemeColor } from "commons/utils/getThemeValue";
import { FC, SVGProps } from "react";
import { MS_ICON_MAP, TMsIconName } from "./iconMap";

export const msIconStyles = css`
  &.success {
    color: ${getThemeStatus("success")};
  }

  &.error {
    color: ${getThemeStatus("error")};
  }

  &.info {
    color: ${getThemeColor("icon")};
  }

  &.warning {
    color: ${getThemeStatus("warning")};
  }
`;

export const MS_STYLED_ICON_MAP = Object.entries(MS_ICON_MAP).reduce((acc, [key, Component]) => {
  acc[key as TMsIconName] = styled(Component)`
    ${msIconStyles}
  ` as FC<SVGProps<SVGSVGElement>>;
  return acc;
}, {} as Record<TMsIconName, FC<SVGProps<SVGSVGElement>>>);
